<template>
  <div class="bottom">
    <div class="bottom__caption">
      <div class="bottom__caption__content">
        <div class="bottom__caption__content__text" v-html="$t('bottom.text')"></div>
        <ui-button
          :label="$t('bottom.cta.label')"
          button="cta"
          variant="engage"
          class="bottom__caption__content__cta"
          :is-link="true"
          :href="$t('bottom.cta.link')"
        ></ui-button>
      </div>
    </div>
    <img :src="require('@/assets/img/svg/logo_bottom.svg')" class="bottom__logo" />
  </div>
</template>

<script>
import UiButton from '@/components/UI/Button.vue'

export default {
  name: 'Bottom',
  components: {
    UiButton,
  },
}
</script>

<style lang="scss" scoped>
.bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &__caption {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;

    &__content {
      display: flex;
      align-items: center;

      &__cta {
        margin-left: 12px;
      }
    }
  }

  &__logo {
    width: 148px;
  }
}
</style>
